<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">账户充值</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 充值顶部  开始 -->
    <div class="page_topmine">
      <div class="account_top">
        <div class="account_jifen">
          <div class="account_jifennum">{{amount}}</div>
          <div class="account_jifentext">账户积分</div>
        </div>
      </div>
    </div>
    <!-- 充值顶部  结束 -->
    <!-- 充值详情  开始 -->
    <div class="page_taocan account_rechargetaocan">
      <div class="page_tab account_detailtop">
        <div class="page_tablist account_rechargetitle">
          充值金额
        </div>
      </div>
      <div class="account_rechargeinput">
        <div class="recharge_text">充值金额:</div>
        <input class="account_rechargedetail_input" placeholder="请输入充值金额" v-model="rechargeNum" />
      </div>
      <div class="account_rechargeinput">
        <div class="recharge_text">到账积分:</div>
        <div class="account_rechargedetail_input">{{rechargeNum ? rechargeNum : 0}}</div>
      </div>
    </div>
    <!-- 充值详情  结束 -->
    <!-- 支付 开始 -->
    <div class="page_button account_rechargelingqu" @click="recharge()">
      <div class="page_zhifu">充值</div>
    </div>
    <!-- 支付 结束 -->
    <!-- 注意事项  开始 -->
    <div class="page_mesg">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">充值说明</div>
      </div>
      <div class="page_mesgtip">如存在无法充值，充值失败等问题，可联系客服<a :href="'tel:' + telNumber">{{telNumber}}</a></div>
    </div>
    <!-- 注意事项  结束 -->
    <!-- <div class="phonenum">客服电话：<a :href="'tel:' + telNumber">{{telNumber}}</a></div> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';

  export default {
    data() {
      return {
        buttonClicked: false, // 防止支付重复点击,默认为false
        amount: '', // 接口获取余额
        rechargeNum:"",//充值金额
        telNumber: "", //客服电话
        receivedNum:""//到账积分
      }
    },
    created() {
      this.request('getUserInfo')
      this.telNumber = sessionStorage.getItem("phoneNumber")
    },
    mounted() {

    },
    methods: {
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //返回上一页
      toReturn() {
        this.$router.go(-1)
      },


      //充值
      recharge() {
        let that = this
        var order_param = {} //下单参数
        this.buttonClickedFun(1000) // 防止重复点击
        if (!(this.rechargeNum)) {
          this.$toast({
            message: '请输入充值金额',
          })
          return
        }
        Dialog.confirm({
            title: '提示',
            message: '确认充值?',
          })
          .then(() => {
            order_param.amount = this.rechargeNum
            // order_param.type = 'online'
            // order_param.product_type = 3
            // order_param.product_item_id = this.id
            // order_param.recharge_number = 0
            // order_param.pay_type = 'wechatpay'
            that.request('WxunifiedOrder', order_param)
          })
          .catch(() => {
            return false;
          });
      },

      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code === 0) {
                let userinfo = res.data
                if (userinfo.mobile) {
                  that.phoneNum = userinfo.mobile
                } else {
                  Dialog.confirm({
                      title: '提示',
                      message: '请先绑定手机',
                    })
                    .then(() => {
                      that.$router.push({
                        path: "/changePhoneNum"
                      })
                    })
                    .catch(() => {
                      return false;
                    });
                }
                that.amount = userinfo.account.amount
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //充值的
          case 'bindCoupon':
            httper.post('card/receive', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '充值成功'
                })
                setTimeout(() => {
                  this.$router.push({
                    path: "/jifenmingxi"
                  })
                }, 3000)
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-integral-recharge', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style>
  .account_top {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
  }

  .account_jifen {}

  .account_jifennum {
    font-size: 26px;
  }

  .account_jifentext {
    font-size: 13px;
    font-weight: 400;
    color: rgba(247, 247, 247, 1);
  }

  .account_kaquanList {
    width: 61px;
    height: 23px;
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 11px;
    font-size: 9px;
    color: rgba(247, 247, 247, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .account_rechargetaocan {
    /* top: 133px; */
    /* height: 230px; */
    /* height: 265px; */
    height: 260px;
    padding: 0;
    /*    width: 90%; */
  }

  .page_tab {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .page_tablist {
    height: 100%;
    position: relative;
  }

  .page_tabname {
    height: 100%;
    display: flex;
    font-size: 13px;
    align-items: center;
  }

  .page_tabname::after {
    content: "";
    top: auto;
    bottom: 0;
    width: 40%;
    position: absolute;
    left: 25%;
    height: 3px;
    background-color: #FD8C00;
  }

  .page_tabname1 {
    height: 100%;
    font-size: 13px;
    display: flex;
    align-items: center;
  }

  .account_detailtop {
    height: 45px;
    border-bottom: 1px solid #dedede;
  }

  .account_rechargetitle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .account_detail_name {}

  .account_rechargeinput {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
  input{
    border: none;
    background:none;
    	outline:none;
  }

  .account_inputchong {
    display: flex;
    align-items: center;
    /* height: 183px; */
    height: 220px;
    flex-direction: column;
  }

  .account_rechargedetail_input {
    width: 248px;
    height: 46px;
    /* height: 46px;
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 7px; */
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 7px;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
  }

  .account_detail_chonginput {
    width: 248px;
    height: 46px;
    border: 1px solid rgba(210, 210, 210, 1);
    border-radius: 7px;
    padding: 0 10px;
    background-color: #fff;
    margin-top: 20px;
  }

  .account_rechargelingqu {
    /* margin-top: 172px; */
    /* margin-top: 195px; */
    margin-top: -40px;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: rgba(187, 187, 187, 1);
    font-size: 14px;
  }

  .scancode {
    width: 269px;
    height: 46px;
    background: #FD8C00;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    margin-top: 20px;
  }

  .scancode-img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }

  .scancode-text {
    font-size: 14px;
  }

  .scancode-tip {
    font-size: 14px;
    color: #FD8C00;
    text-align: center;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/IntegralRecharge.vue